import graph from "./graph";
import schema from "./schema";
import uiSchema from "./uiSchema";
import React, { useState } from "react";

import {
  NewDialog,
  NewDialogTitle,
  NewDialogContent,
  NewDialogActions,
} from "components";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { MuiFormBuilder } from "components";
import { useMutation } from "@apollo/client";
import { Stack, Button } from "@mui/material";
import { isEmptyObject } from "helpers/formatObject";

export default function Reject({ id, title = "رد درخواست", refetch }) {
  const [open, setOpen] = useState(false);
  // const [formData, setFormData] = useState({});
  const { userToken } = useSelector((state) => state.auth);
  const [reject, { loading }] = useMutation(graph.reject.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const onReject = async ({ formData }) => {
    try {
      const { data, errors } = await reject({
        context: {
          serviceName: graph.reject.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          id,
          details: formData?.details,
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.reject.name]?.messages.map((message) =>
            toast.success(String(message))
          );
        }
      }
    } catch (error) {}
  };

  return (
    <>
      <Button
        color="error"
        size="medium"
        variant="outlined"
        sx={{ minWidth: 80 }}
        onClick={onOpen}
        disabled={loading}
      >
        {title}
      </Button>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={2} rowGap={2} bgcolor="background.paper">
            <MuiFormBuilder
              id="submit"
              showSubmit={false}
              schema={schema()}
              uiSchema={uiSchema()}
              // formData={formData}
              onSubmit={onReject}
            />
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            size="large"
            type="submit"
            form="submit"
            color="error"
            variant="contained"
            sx={{ minWidth: 120 }}
            disabled={loading}
          >
            {title}
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
